
import { Route, Routes } from "react-router"
import ProtectedRouteAuth from "./ProtectedRouteAuth";
import { routesData } from "./routesData";
import { useSelector } from "react-redux";
import PageNotFound from "../Component/Layout/NotFound";


const { unProtectedRoutes, protectedRoutes } = routesData

const UIRoutes = () => {

  const isLoggedIn = useSelector((state) => state.authTracking.isLoggedIn);

  // const isLoggedIn = localStorage.getItem("isLoggedIn") === "true"; 
 

  const filterRouteWithAccess = (route) => { 
    return true
  }

  const alwaysAccessibleRoutes = ["/privacy_policy", "/terms_conditions", "/contact_us"];


  return (
    <Routes>
      {!isLoggedIn &&
        unProtectedRoutes.map((route, index) => <Route key={index} path={route.path} element={route.component} />)}

       {/* Render specific unprotected routes even when logged in */}
       {unProtectedRoutes
        .filter((route) => alwaysAccessibleRoutes.includes(route.path))
        .map((route, index) => (
          <Route key={`public-${index}`} path={route.path} element={route.component} />
        ))}

      <Route element={<ProtectedRouteAuth isLoggedIn={isLoggedIn} />}>
        {protectedRoutes.filter(filterRouteWithAccess).map((route, index) => (
          <Route key={index} path={route.path} element={route.component}>
            {route.subRoutes &&
              route.subRoutes.map((subRoute, subIndex) => (
                <Route key={subIndex} path={subRoute.path} element={subRoute.component} />
              ))}
          </Route>
        ))}

        <Route path="*" element={<PageNotFound />} />
      </Route>
    </Routes>
  )
}

export default UIRoutes
